import { useTranslation } from "react-i18next";
import { Box, TextField } from "@mui/material";
import LogoSvg from "../../atoms/LogoSvg/LogoSvg";
import ActiveButton from "../../../assets/images/RADIO-BUTTON-ACTIVE.svg";
import InactiveButton from "../../../assets/images/RADIO-BUTTON-INACTIVE.svg";
import Text from "../../atoms/Text/Text";

interface Props {
  index: number;
  isActive: boolean;
  onSelect: () => void;
  translationKey: string;
  textValue?: string;
  onTextChange?: (value: string) => void;
  textFieldPlaceholder?: string;
}

const ReviewCard = ({ 
  index, 
  isActive, 
  onSelect, 
  translationKey,
  textValue = "",
  onTextChange,
  textFieldPlaceholder
}: Props) => {
  const { t } = useTranslation();

  return (
    <Box className={`ReviewCard ${isActive && "isReviewCardActive"}`} onClick={onSelect}>
      <Box className="cardRadioButton">
        <LogoSvg src={isActive ? ActiveButton : InactiveButton} />
      </Box>
      <Box className="cardContent">
        <Text className="title" children={t(translationKey)} />
        {isActive && textFieldPlaceholder && (
          <Box onClick={(e) => e.stopPropagation()}>
            <TextField
              value={textValue}
              onChange={(e) => onTextChange?.(e.target.value)}
              placeholder={textFieldPlaceholder}
              multiline
              inputProps={{ maxLength: 255 }}
            />
          </Box>
        )}
      </Box>
      
    </Box>
  );
};

export default ReviewCard;